/* hs-eslint ignored failing-rules */

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import { NavMarker } from 'react-rhumb';
import TwoFactorRecoveryForm from './TwoFactorRecoveryForm';
import { verifyTwoFactorAdminRecoveryEligibility } from '../../../actions/twoFactorRecovery';
import { getIsAdminRecoveryEligible, getIsLoadingAdminRecoveryEligibility, getHasAdminRecoveryEligibilityRequestExpired, getIsAdminRecoveryForced
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
} from '../../../selectors/TwoFactorRecovery';
import { getToken } from '../../../selectors/TwoFactorAuth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class TwoFactorRecoveryPage extends Component {
  constructor(...args) {
    super(...args);
    this.twoFactorRecoveryRedirect = () => {
      const {
        isAdminVerifyEligible,
        isAdminVerifyForced,
        isTokenExpired
      } = this.props;
      if (isTokenExpired) {
        return;
      }
      if (!isAdminVerifyEligible) {
        this.props.history.push('/two-factor/support-recovery');
      }
      if (isAdminVerifyForced) {
        this.props.history.push('/two-factor/admin-recovery');
      }
    };
    this.onAdminRecoveryPressed = () => {
      this.props.history.push('/two-factor/admin-recovery');
    };
    this.onSupportRecoveryPressed = () => {
      this.props.history.push('/two-factor/support-recovery');
    };
    this.renderLoadingScreen = () => {
      return /*#__PURE__*/_jsx(NavMarker, {
        name: "TWO_FACTOR_RECOVERY_LOADING",
        children: /*#__PURE__*/_jsxs(Text, {
          textAlign: "center",
          paddingBlockStart: "200",
          children: [/*#__PURE__*/_jsx(LoadingSpinner, {
            grow: true,
            minHeight: 100
          }), /*#__PURE__*/_jsx("h1", {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: `login.loading.default`
            })
          })]
        })
      });
    };
  }
  componentDidMount() {
    const {
      token,
      verify2FAdminRecovery
    } = this.props;
    if (token === null) {
      this.props.history.push('/');
      return;
    }
    /* eslint-disable-next-line promise/catch-or-return */
    verify2FAdminRecovery(token).then(this.twoFactorRecoveryRedirect);
  }
  render() {
    const {
      isLoadingAdminRecoveryEligibility,
      isTokenExpired
    } = this.props;
    if (isLoadingAdminRecoveryEligibility) {
      return this.renderLoadingScreen();
    }
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "TWO_FACTOR_RECOVERY_LOAD",
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        alignSelf: "center",
        justifyContent: "center",
        flexDirection: "column",
        paddingBlockStart: "500",
        children: /*#__PURE__*/_jsx(View, {
          maxInlineSize: "500px",
          children: /*#__PURE__*/_jsx(TwoFactorRecoveryForm, {
            onAdminRecoveryPressed: this.onAdminRecoveryPressed,
            onSupportRecoveryPressed: this.onSupportRecoveryPressed,
            isTokenExpired: isTokenExpired
          })
        })
      })
    });
  }
}
TwoFactorRecoveryPage.propTypes = {
  history: PropTypes.object.isRequired,
  token: PropTypes.string,
  isTokenExpired: PropTypes.bool.isRequired,
  verify2FAdminRecovery: PropTypes.func.isRequired,
  isAdminVerifyEligible: PropTypes.bool.isRequired,
  isAdminVerifyForced: PropTypes.bool.isRequired,
  isLoadingAdminRecoveryEligibility: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
  token: getToken(state),
  isAdminVerifyEligible: getIsAdminRecoveryEligible(state),
  isAdminVerifyForced: getIsAdminRecoveryForced(state),
  isLoadingAdminRecoveryEligibility: getIsLoadingAdminRecoveryEligibility(state),
  isTokenExpired: getHasAdminRecoveryEligibilityRequestExpired(state)
});
const reduxConnect = connect(mapStateToProps, {
  verify2FAdminRecovery: verifyTwoFactorAdminRecoveryEligibility
});

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof TwoFactorRecoveryPage' is... Remove this comment to see the full error message
export default reduxConnect(TwoFactorRecoveryPage);